import { deleteDocument } from 'resources/document/workflows';

import taskService from 'resources/task/task.service';
import commentService from 'resources/comment/comment.service';
import documentService from 'resources/document/document.service';

import { resolveAuditComments } from 'resources/comment/workflows';

/**
 * Delete a single task with its documents
 * @param id
 * @returns {Promise<*|null>}
 */
const deleteTask = async ({ id }) => {
  const [documents, taskAuditCommentsToResolve] = await Promise.all([
    documentService.getByTaskId(id),
    commentService.getTaskAuditCommentsToResolve(id),
  ]);

  await Promise.all([
    (documents && Promise.all(documents.map((d) => deleteDocument(d.id)))),
    (taskAuditCommentsToResolve && resolveAuditComments({ taskId: id, resolvedBy: null })),
  ]);

  const removedTask = await taskService.removeTask(id);

  if (!removedTask) {
    return null;
  }

  return removedTask;
};

export {
  deleteTask,
};
